(function () {
    'use strict';

    a3_cabin_reports.directive('traineeCoursesDetails', traineeCoursesDetails);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name traineeCoursesDetails
    * @restrict E
    * @description
    *    Implementation of trainee Courses Details
    * @example
    *   Usage:
    *   <trainee-courses-details></trainee-courses-details>
    * @ngInject
    */
    function traineeCoursesDetails(TraineeCoursesDetailsFactory, $location, $uibModal, $routeParams) {
        function link(scope, attrs) {
            // scope.getTraineeCourse = getTraineeCourse;
            scope.goToTraineeCourse = goToTraineeCourse;
            scope.goToTraineeFlightCourse = goToTraineeFlightCourse;
            scope.HasTraineeView = true;
            scope.isLoading = false;
            scope.traineeCourses = [];
            scope.traineeFlightCourses = [];

            var dutyId = scope.groundDutyId;
            if(dutyId != null){
                scope.traineeCourses = TraineeCoursesDetailsFactory.getTraineeGroundCourses(dutyId); 
            }

            if(scope.flightId != null || scope.Flight != null){
                var flightId = scope.flightId != null ? scope.flightId : scope.Flight.FlightId;
            }	
            if(flightId != null){
                scope.traineeFlightCourses = TraineeCoursesDetailsFactory.getTraineeFlightCourses(flightId); 	
            } 		
   
            if(scope.traineeCourses.length > 0){
                var date = scope.groundDuty.DutyDateS;
            }
         
            if(scope.traineeFlightCourses.length > 0){
                var flightDate = new moment(scope.flight.FlightDate).format("DD-MM-YYYY");
            }
            manageCourseStatus(scope.traineeCourses, scope.traineeFlightCourses);

            function manageCourseStatus(traineeCourses, traineeFlightCourses){  
                traineeCourses.forEach(course => {
                       //Pending
                     if(course.Status == "1"){
                        course.StatusClass = "text-blue";
                     }
                     //Completed
                    else if(course.Status == "2"){
                        course.StatusClass = "text-green";

                    }
                    //NotCompleted - stopped
                    else if(course.Status == "5"){
                        course.StatusClass = "text-orange";

                    }
                });    
                    traineeFlightCourses.forEach(course => {
                        //Pending
                      if(course.Status == "1"){
                         course.StatusClass = "text-blue";
                      }
                      //Completed
                     else if(course.Status == "2"){
                         course.StatusClass = "text-green";
 
                     }
                     //NotCompleted - stopped
                     else if(course.Status == "5"){
                         course.StatusClass = "text-orange";
 
                     }
 
                });               

            }

             /**
             * Redirect to Course Session
             */
             function goToTraineeCourse(traineeCourseId) {
                $location.path('/traineecourse/' + traineeCourseId + '/' + dutyId + '/' + date);
            }

            function goToTraineeFlightCourse(traineeCourseId){
                $location.path('/traineecourse/' + traineeCourseId + '/' + flightId + '/' + flightDate);
            }
        }

        return {
            restrict: 'E',
            terminal: true,
            templateUrl: 'views/TraineeCourse/trainee-courses-details.tpl.html',
            scope: false,
            link: link
        }
    }

})();
